import { useState, useCallback } from "react";

type ToastVariant = "default" | "destructive" | "success";

interface Toast {
  id: string;
  title?: string;
  description?: string;
  variant?: ToastVariant;
  duration?: number;
}

type ToastInput = Omit<Toast, "id">;

// Global singleton so toast can be called from anywhere
let externalSetToasts: React.Dispatch<React.SetStateAction<Toast[]>> | null = null;

function generateId(): string {
  return Math.random().toString(36).slice(2, 9);
}

export function toast(input: ToastInput): void {
  if (!externalSetToasts) return;

  const id = generateId();
  const duration = input.duration ?? 3500;

  externalSetToasts((prev) => [...prev, { id, ...input }]);

  setTimeout(() => {
    externalSetToasts?.((prev) => prev.filter((t) => t.id !== id));
  }, duration);
}

export function useToast() {
  const [toasts, setToasts] = useState<Toast[]>([]);

  // Register this instance as the global handler
  externalSetToasts = setToasts;

  const dismiss = useCallback((id: string) => {
    setToasts((prev) => prev.filter((t) => t.id !== id));
  }, []);

  return { toasts, dismiss };
}
